<template>
  <LoadingContainer :is-loading="isLoadingModel">
    <form novalidate @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">
            <div class="title is-6 is-marginless">
              Επεξεργασία Λόγου Διαγραφής Παραγγελίας
              <span class="tag">{{ model.title }}</span>
            </div>
          </div>
          <div class="card-header-icon">
            <div class="field">
              <div class="control">
                <router-link
                  :to="{ name: 'settings.cancelOrderReasons.list' }"
                  class="button"
                >
                  <span class="icon is-small"><i class="fa fa-list"/></span
                  ><span>Λίστα</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="field">
            <label class="label">Τίτλος *</label>
            <div class="control">
              <input
                v-model.number="newModel.title"
                type="text"
                class="input"
                name="title"
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <FormSubmit :is-saving="isSaving" @reset="reset" />
        </div>
      </div>
    </form>
  </LoadingContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _pick from 'lodash/pick';
import AddItem from '@/views/components/AddItem';
import ToggleableCard from '@/views/components/ToggleableCard';
import LoadingContainer from '@/views/components/LoadingContainer';

export default {
  components: {
    ToggleableCard,
    LoadingContainer,
  },
  extends: AddItem,
  data() {
    return {
      newModel: {},
    };
  },
  computed: {
    ...mapGetters({
      model: 'cancelOrderReasons/edit/getCancelOrderReason',
      isLoadingModel: 'cancelOrderReasons/edit/getIsLoading',
    }),
  },
  watch: {
    model: {
      handler(newVal) {
        this.newModel = _pick(newVal, ['title']);
      },
      deep: true,
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    ...mapActions({
      getCancelOrderReason: 'cancelOrderReasons/edit/getCancelOrderReason',
      updateCancelOrderReason:
        'cancelOrderReasons/edit/updateCancelOrderReason',
    }),
    async fetchData() {
      try {
        await this.getCancelOrderReason({ uuid: this.$route.params.uuid });
      } catch (err) {
        this.$router.push('/error');
      }
    },
    async submit() {
      try {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          throw Error('Client-side validation failed');
        }

        this.isSaving = true;
        await this.updateCancelOrderReason({
          cancelOrderReason: this.newModel,
          uuid: this.model.uuid,
        });
        this.isSaving = false;

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Tα στοιχεία αποθηκεύτηκαν',
        });
      } catch (err) {
        this.isSaving = false;
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
    reset() {
      this.newModel = _pick(this.model, ['title']);

      this.$validator.reset();
    },
  },
};
</script>
